import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/1f18a76f-ed3f-4e88-bb38-b62c775c3336/2a2727fb-d43e-4311-98ff-6ddfb958da4d_ChatGPT-Image-Jun-16-2026-10_46_43-AM.png"
          alt="Serena Raimes in a serene, bright living room, holding a cup of tea with warm natural light, a peaceful and inviting home atmosphere"
          className="w-full h-full object-cover object-right"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/25"></div>
      </div>

      <div className="relative w-full z-10">
        <div className="w-full px-4 sm:px-6 lg:px-10 py-20 md:py-28">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
            <div className="w-full md:w-3/5">
              <div className="mb-8">
                <img
                  src="https://storage.readdy-site.link/project_files/1f18a76f-ed3f-4e88-bb38-b62c775c3336/dd8305a0-1fac-4e33-aa4a-430f46df46f4_ChatGPT-Image-Jun-9-2026-03_24_23-PM.png?v=ad55fcfd6c6876a070c9edc39cde37f1"
                  alt="Serena's Quiet Recovery Space logo"
                  title="Serena's Quiet Recovery Space - Private Recovery Support"
                  className="w-80 h-80 md:w-96 md:h-96 rounded-full object-cover shadow-lg"
                />
              </div>

              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-background-50 leading-tight mb-6">
                Are you a successful professional on the outside?
                <br />
                Struggling in silence on the inside?
              </h2>

              <p className="font-heading text-lg md:text-xl text-background-200 font-light leading-relaxed mb-8 max-w-xl">
                A private, discreet online recovery course from alcohol addiction with <strong>1:1 support</strong> — designed for professionals who want to understand and change their own relationship with alcohol, <strong>confidentially and at their own pace</strong>.
              </p>

              <div className="mb-8 space-y-2">
                <p className="font-heading text-base md:text-lg text-background-200 font-light">No public meetings</p>
                <p className="font-heading text-base md:text-lg text-background-200 font-light">No judgement</p>
                <p className="font-heading text-base md:text-lg text-background-200 font-light">Just a safe, discreet place to begin</p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a
                  href="https://calendly.com/sraimes43/30min"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-block bg-accent-500 text-background-50 font-body text-sm font-medium px-8 py-3 rounded-md hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  Book a Quiet Conversation
                </a>
                <Link
                  to="/support"
                  className="inline-block border border-background-200/40 text-background-100 font-body text-sm font-medium px-8 py-3 rounded-md hover:bg-background-100/10 transition-all duration-300 whitespace-nowrap text-center"
                >
                  Explore Support
                </Link>
              </div>

              <p className="font-body text-xs text-background-300 flex flex-wrap gap-2 sm:gap-3 tracking-wide">
                <span>Private</span><span className="opacity-50">&bull;</span>
                <span>Supportive</span><span className="opacity-50">&bull;</span>
                <span>Non-judgemental</span><span className="opacity-50">&bull;</span>
                <span>From the comfort of home</span>
              </p>
            </div>

            <div className="hidden md:block md:w-2/5"></div>
          </div>
        </div>
      </div>
    </section>
  );
}